import React from "react";
import {FaGithub, FaLinkedin} from "react-icons/fa";

export default function SocialMedia() {
  return (
    <div className="flex flex-col gap-5">
      <div className="flex items-center gap-3.5">
        <span className="font-mono text-[11px] text-muted2 w-16 shrink-0">EMAIL</span>
        <a href="mailto:dineshkhawas123@gmail.com" className="font-mono text-sm hover:text-amber transition-colors">
          dineshkhawas123@gmail.com
        </a>
      </div>
      <div className="flex items-center gap-3.5">
        <span className="font-mono text-[11px] text-muted2 w-16 shrink-0">LOCATION</span>
        <span className="font-mono text-sm">Airport-8, Pokhara, NP</span>
      </div>
      <div className="flex items-center gap-3.5">
        <span className="font-mono text-[11px] text-muted2 w-16 shrink-0">GITHUB</span>
        <a
          href="https://github.com/Dinesh-Thakuri"
          target="_blank"
          rel="noopener noreferrer"
          className="font-mono text-sm hover:text-amber transition-colors">
          Dinesh-Thakuri
        </a>
      </div>

      <div className="flex items-center gap-4 pt-2">
        <a
          href="https://github.com/Dinesh-Thakuri"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="GitHub"
          className="text-muted hover:text-white transition-colors">
          <FaGithub size={20} />
        </a>
        <a
          href="https://https://www.linkedin.com/in/dinesh-khawas-062aa021b//"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="LinkedIn"
          className="text-muted hover:text-white transition-colors">
          <FaLinkedin size={20} />
        </a>
      </div>
    </div>
  );
}
